
















import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class AppLogo extends Vue {
  @Prop({ required: true })
  filename!: string; // e.g. banner-large.png

  @Prop({ required: true })
  alt!: string;

  @Prop({ required: true })
  width!: number; // e.g. 600

  @Prop({ required: true })
  tagline!: string;

  @Prop({ required: true })
  maxWidth!: string; // e.g. 252px
}
